import ScrollToElement from './scrollToElement'

export default ScrollToElement
